export interface Country {
    code: string;
    name: string;
    nameEn: string;
}

export const COUNTRIES: Country[] = [
    { code: 'AF', name: 'Afeganistão', nameEn: 'Afghanistan' },
    { code: 'ZA', name: 'África do Sul', nameEn: 'South Africa' },
    { code: 'AL', name: 'Albânia', nameEn: 'Albania' },
    { code: 'DE', name: 'Alemanha', nameEn: 'Germany' },
    { code: 'AD', name: 'Andorra', nameEn: 'Andorra' },
    { code: 'AO', name: 'Angola', nameEn: 'Angola' },
    { code: 'AG', name: 'Antígua e Barbuda', nameEn: 'Antigua and Barbuda' },
    { code: 'SA', name: 'Arábia Saudita', nameEn: 'Saudi Arabia' },
    { code: 'DZ', name: 'Argélia', nameEn: 'Algeria' },
    { code: 'AR', name: 'Argentina', nameEn: 'Argentina' },
    { code: 'AM', name: 'Armênia', nameEn: 'Armenia' },
    { code: 'AU', name: 'Austrália', nameEn: 'Australia' },
    { code: 'AT', name: 'Áustria', nameEn: 'Austria' },
    { code: 'AZ', name: 'Azerbaijão', nameEn: 'Azerbaijan' },
    { code: 'BS', name: 'Bahamas', nameEn: 'Bahamas' },
    { code: 'BD', name: 'Bangladesh', nameEn: 'Bangladesh' },
    { code: 'BB', name: 'Barbados', nameEn: 'Barbados' },
    { code: 'BH', name: 'Bahrein', nameEn: 'Bahrain' },
    { code: 'BE', name: 'Bélgica', nameEn: 'Belgium' },
    { code: 'BZ', name: 'Belize', nameEn: 'Belize' },
    { code: 'BJ', name: 'Benin', nameEn: 'Benin' },
    { code: 'BY', name: 'Bielorrússia', nameEn: 'Belarus' },
    { code: 'BO', name: 'Bolívia', nameEn: 'Bolivia' },
    { code: 'BA', name: 'Bósnia e Herzegovina', nameEn: 'Bosnia and Herzegovina' },
    { code: 'BW', name: 'Botsuana', nameEn: 'Botswana' },
    { code: 'BR', name: 'Brasil', nameEn: 'Brazil' },
    { code: 'BN', name: 'Brunei', nameEn: 'Brunei' },
    { code: 'BG', name: 'Bulgária', nameEn: 'Bulgaria' },
    { code: 'BF', name: 'Burkina Faso', nameEn: 'Burkina Faso' },
    { code: 'BI', name: 'Burundi', nameEn: 'Burundi' },
    { code: 'BT', name: 'Butão', nameEn: 'Bhutan' },
    { code: 'CV', name: 'Cabo Verde', nameEn: 'Cape Verde' },
    { code: 'CM', name: 'Camarões', nameEn: 'Cameroon' },
    { code: 'KH', name: 'Camboja', nameEn: 'Cambodia' },
    { code: 'CA', name: 'Canadá', nameEn: 'Canada' },
    { code: 'QA', name: 'Catar', nameEn: 'Qatar' },
    { code: 'KZ', name: 'Cazaquistão', nameEn: 'Kazakhstan' },
    { code: 'TD', name: 'Chade', nameEn: 'Chad' },
    { code: 'CL', name: 'Chile', nameEn: 'Chile' },
    { code: 'CN', name: 'China', nameEn: 'China' },
    { code: 'CY', name: 'Chipre', nameEn: 'Cyprus' },
    { code: 'CO', name: 'Colômbia', nameEn: 'Colombia' },
    { code: 'KM', name: 'Comores', nameEn: 'Comoros' },
    { code: 'CG', name: 'Congo', nameEn: 'Congo' },
    { code: 'CD', name: 'Congo (RDC)', nameEn: 'Congo (DRC)' },
    { code: 'KP', name: 'Coreia do Norte', nameEn: 'North Korea' },
    { code: 'KR', name: 'Coreia do Sul', nameEn: 'South Korea' },
    { code: 'CI', name: 'Costa do Marfim', nameEn: 'Ivory Coast' },
    { code: 'CR', name: 'Costa Rica', nameEn: 'Costa Rica' },
    { code: 'HR', name: 'Croácia', nameEn: 'Croatia' },
    { code: 'CU', name: 'Cuba', nameEn: 'Cuba' },
    { code: 'DK', name: 'Dinamarca', nameEn: 'Denmark' },
    { code: 'DJ', name: 'Djibuti', nameEn: 'Djibouti' },
    { code: 'DM', name: 'Dominica', nameEn: 'Dominica' },
    { code: 'EG', name: 'Egito', nameEn: 'Egypt' },
    { code: 'SV', name: 'El Salvador', nameEn: 'El Salvador' },
    { code: 'AE', name: 'Emirados Árabes', nameEn: 'United Arab Emirates' },
    { code: 'EC', name: 'Equador', nameEn: 'Ecuador' },
    { code: 'ER', name: 'Eritreia', nameEn: 'Eritrea' },
    { code: 'SK', name: 'Eslováquia', nameEn: 'Slovakia' },
    { code: 'SI', name: 'Eslovênia', nameEn: 'Slovenia' },
    { code: 'ES', name: 'Espanha', nameEn: 'Spain' },
    { code: 'US', name: 'Estados Unidos', nameEn: 'United States' },
    { code: 'EE', name: 'Estônia', nameEn: 'Estonia' },
    { code: 'SZ', name: 'Essuatíni', nameEn: 'Eswatini' },
    { code: 'ET', name: 'Etiópia', nameEn: 'Ethiopia' },
    { code: 'FJ', name: 'Fiji', nameEn: 'Fiji' },
    { code: 'PH', name: 'Filipinas', nameEn: 'Philippines' },
    { code: 'FI', name: 'Finlândia', nameEn: 'Finland' },
    { code: 'FR', name: 'França', nameEn: 'France' },
    { code: 'GA', name: 'Gabão', nameEn: 'Gabon' },
    { code: 'GM', name: 'Gâmbia', nameEn: 'Gambia' },
    { code: 'GH', name: 'Gana', nameEn: 'Ghana' },
    { code: 'GE', name: 'Geórgia', nameEn: 'Georgia' },
    { code: 'GD', name: 'Granada', nameEn: 'Grenada' },
    { code: 'GR', name: 'Grécia', nameEn: 'Greece' },
    { code: 'GT', name: 'Guatemala', nameEn: 'Guatemala' },
    { code: 'GY', name: 'Guiana', nameEn: 'Guyana' },
    { code: 'GN', name: 'Guiné', nameEn: 'Guinea' },
    { code: 'GQ', name: 'Guiné Equatorial', nameEn: 'Equatorial Guinea' },
    { code: 'GW', name: 'Guiné-Bissau', nameEn: 'Guinea-Bissau' },
    { code: 'HT', name: 'Haiti', nameEn: 'Haiti' },
    { code: 'HN', name: 'Honduras', nameEn: 'Honduras' },
    { code: 'HU', name: 'Hungria', nameEn: 'Hungary' },
    { code: 'YE', name: 'Iêmen', nameEn: 'Yemen' },
    { code: 'IN', name: 'Índia', nameEn: 'India' },
    { code: 'ID', name: 'Indonésia', nameEn: 'Indonesia' },
    { code: 'IQ', name: 'Iraque', nameEn: 'Iraq' },
    { code: 'IR', name: 'Irã', nameEn: 'Iran' },
    { code: 'IE', name: 'Irlanda', nameEn: 'Ireland' },
    { code: 'IS', name: 'Islândia', nameEn: 'Iceland' },
    { code: 'IL', name: 'Israel', nameEn: 'Israel' },
    { code: 'IT', name: 'Itália', nameEn: 'Italy' },
    { code: 'JM', name: 'Jamaica', nameEn: 'Jamaica' },
    { code: 'JP', name: 'Japão', nameEn: 'Japan' },
    { code: 'JO', name: 'Jordânia', nameEn: 'Jordan' },
    { code: 'KE', name: 'Quênia', nameEn: 'Kenya' },
    { code: 'KI', name: 'Kiribati', nameEn: 'Kiribati' },
    { code: 'KW', name: 'Kuwait', nameEn: 'Kuwait' },
    { code: 'KG', name: 'Quirguistão', nameEn: 'Kyrgyzstan' },
    { code: 'LA', name: 'Laos', nameEn: 'Laos' },
    { code: 'LS', name: 'Lesoto', nameEn: 'Lesotho' },
    { code: 'LV', name: 'Letônia', nameEn: 'Latvia' },
    { code: 'LB', name: 'Líbano', nameEn: 'Lebanon' },
    { code: 'LR', name: 'Libéria', nameEn: 'Liberia' },
    { code: 'LY', name: 'Líbia', nameEn: 'Libya' },
    { code: 'LI', name: 'Liechtenstein', nameEn: 'Liechtenstein' },
    { code: 'LT', name: 'Lituânia', nameEn: 'Lithuania' },
    { code: 'LU', name: 'Luxemburgo', nameEn: 'Luxembourg' },
    { code: 'MK', name: 'Macedônia do Norte', nameEn: 'North Macedonia' },
    { code: 'MG', name: 'Madagascar', nameEn: 'Madagascar' },
    { code: 'MY', name: 'Malásia', nameEn: 'Malaysia' },
    { code: 'MW', name: 'Maláui', nameEn: 'Malawi' },
    { code: 'MV', name: 'Maldivas', nameEn: 'Maldives' },
    { code: 'ML', name: 'Mali', nameEn: 'Mali' },
    { code: 'MT', name: 'Malta', nameEn: 'Malta' },
    { code: 'MA', name: 'Marrocos', nameEn: 'Morocco' },
    { code: 'MH', name: 'Ilhas Marshall', nameEn: 'Marshall Islands' },
    { code: 'MU', name: 'Maurício', nameEn: 'Mauritius' },
    { code: 'MR', name: 'Mauritânia', nameEn: 'Mauritania' },
    { code: 'MX', name: 'México', nameEn: 'Mexico' },
    { code: 'FM', name: 'Micronésia', nameEn: 'Micronesia' },
    { code: 'MZ', name: 'Moçambique', nameEn: 'Mozambique' },
    { code: 'MD', name: 'Moldávia', nameEn: 'Moldova' },
    { code: 'MC', name: 'Mônaco', nameEn: 'Monaco' },
    { code: 'MN', name: 'Mongólia', nameEn: 'Mongolia' },
    { code: 'ME', name: 'Montenegro', nameEn: 'Montenegro' },
    { code: 'MM', name: 'Mianmar', nameEn: 'Myanmar' },
    { code: 'NA', name: 'Namíbia', nameEn: 'Namibia' },
    { code: 'NR', name: 'Nauru', nameEn: 'Nauru' },
    { code: 'NP', name: 'Nepal', nameEn: 'Nepal' },
    { code: 'NI', name: 'Nicarágua', nameEn: 'Nicaragua' },
    { code: 'NE', name: 'Níger', nameEn: 'Niger' },
    { code: 'NG', name: 'Nigéria', nameEn: 'Nigeria' },
    { code: 'NO', name: 'Noruega', nameEn: 'Norway' },
    { code: 'NZ', name: 'Nova Zelândia', nameEn: 'New Zealand' },
    { code: 'OM', name: 'Omã', nameEn: 'Oman' },
    { code: 'NL', name: 'Países Baixos', nameEn: 'Netherlands' },
    { code: 'PW', name: 'Palau', nameEn: 'Palau' },
    { code: 'PA', name: 'Panamá', nameEn: 'Panama' },
    { code: 'PG', name: 'Papua-Nova Guiné', nameEn: 'Papua New Guinea' },
    { code: 'PK', name: 'Paquistão', nameEn: 'Pakistan' },
    { code: 'PY', name: 'Paraguai', nameEn: 'Paraguay' },
    { code: 'PE', name: 'Peru', nameEn: 'Peru' },
    { code: 'PL', name: 'Polônia', nameEn: 'Poland' },
    { code: 'PT', name: 'Portugal', nameEn: 'Portugal' },
    { code: 'RO', name: 'Romênia', nameEn: 'Romania' },
    { code: 'RW', name: 'Ruanda', nameEn: 'Rwanda' },
    { code: 'RU', name: 'Rússia', nameEn: 'Russia' },
    { code: 'KN', name: 'São Cristóvão e Névis', nameEn: 'Saint Kitts and Nevis' },
    { code: 'SM', name: 'San Marino', nameEn: 'San Marino' },
    { code: 'LC', name: 'Santa Lúcia', nameEn: 'Saint Lucia' },
    { code: 'VC', name: 'São Vicente e Granadinas', nameEn: 'Saint Vincent and the Grenadines' },
    { code: 'ST', name: 'São Tomé e Príncipe', nameEn: 'Sao Tome and Principe' },
    { code: 'WS', name: 'Samoa', nameEn: 'Samoa' },
    { code: 'SN', name: 'Senegal', nameEn: 'Senegal' },
    { code: 'SL', name: 'Serra Leoa', nameEn: 'Sierra Leone' },
    { code: 'RS', name: 'Sérvia', nameEn: 'Serbia' },
    { code: 'SC', name: 'Seicheles', nameEn: 'Seychelles' },
    { code: 'SG', name: 'Singapura', nameEn: 'Singapore' },
    { code: 'SY', name: 'Síria', nameEn: 'Syria' },
    { code: 'SO', name: 'Somália', nameEn: 'Somalia' },
    { code: 'LK', name: 'Sri Lanka', nameEn: 'Sri Lanka' },
    { code: 'SD', name: 'Sudão', nameEn: 'Sudan' },
    { code: 'SS', name: 'Sudão do Sul', nameEn: 'South Sudan' },
    { code: 'SE', name: 'Suécia', nameEn: 'Sweden' },
    { code: 'CH', name: 'Suíça', nameEn: 'Switzerland' },
    { code: 'SR', name: 'Suriname', nameEn: 'Suriname' },
    { code: 'TJ', name: 'Tajiquistão', nameEn: 'Tajikistan' },
    { code: 'TH', name: 'Tailândia', nameEn: 'Thailand' },
    { code: 'TZ', name: 'Tanzânia', nameEn: 'Tanzania' },
    { code: 'CZ', name: 'Tchéquia', nameEn: 'Czech Republic' },
    { code: 'TL', name: 'Timor-Leste', nameEn: 'Timor-Leste' },
    { code: 'TG', name: 'Togo', nameEn: 'Togo' },
    { code: 'TO', name: 'Tonga', nameEn: 'Tonga' },
    { code: 'TT', name: 'Trinidad e Tobago', nameEn: 'Trinidad and Tobago' },
    { code: 'TN', name: 'Tunísia', nameEn: 'Tunisia' },
    { code: 'TM', name: 'Turcomenistão', nameEn: 'Turkmenistan' },
    { code: 'TR', name: 'Turquia', nameEn: 'Turkey' },
    { code: 'TV', name: 'Tuvalu', nameEn: 'Tuvalu' },
    { code: 'UA', name: 'Ucrânia', nameEn: 'Ukraine' },
    { code: 'UG', name: 'Uganda', nameEn: 'Uganda' },
    { code: 'UY', name: 'Uruguai', nameEn: 'Uruguay' },
    { code: 'UZ', name: 'Uzbequistão', nameEn: 'Uzbekistan' },
    { code: 'VU', name: 'Vanuatu', nameEn: 'Vanuatu' },
    { code: 'VA', name: 'Vaticano', nameEn: 'Vatican City' },
    { code: 'VE', name: 'Venezuela', nameEn: 'Venezuela' },
    { code: 'VN', name: 'Vietnã', nameEn: 'Vietnam' },
    { code: 'ZM', name: 'Zâmbia', nameEn: 'Zambia' },
    { code: 'ZW', name: 'Zimbábue', nameEn: 'Zimbabwe' },
];
